/* eslint-disable @typescript-eslint/no-explicit-any */
// Safe gtag wrapper — calls window.gtag only if it exists
export function gtagEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, params);
  }
}

// Predefined conversion events
export function trackContactFormSubmit(extra?: Record<string, any>) {
  gtagEvent('contact_form_submit', {
    event_category: 'conversion',
    event_label: 'contact',
    ...extra,
  });
}

export function trackProductInquiry(productName: string, productId?: string | number, extra?: Record<string, any>) {
  gtagEvent('product_inquiry', {
    event_category: 'conversion',
    event_label: productName,
    product_name: productName,
    product_id: productId ? String(productId) : undefined,
    ...extra,
  });
}

export function trackGetQuoteClick(context: string, extra?: Record<string, any>) {
  gtagEvent('get_quote_click', {
    event_category: 'conversion',
    event_label: context,
    ...extra,
  });
}

export function trackWhatsAppClick(context: string, extra?: Record<string, any>) {
  gtagEvent('whatsapp_click', {
    event_category: 'engagement',
    event_label: context,
    ...extra,
  });
}

export function trackViewItem(product: {
  id: string | number;
  name: string;
  category?: string | null;
  price?: number | null;
  currency?: string;
}, extra?: Record<string, any>) {
  gtagEvent('view_item', {
    currency: product.currency || 'USD',
    value: product.price ?? undefined,
    items: [
      {
        item_id: String(product.id),
        item_name: product.name,
        item_category: product.category || undefined,
        price: product.price ?? undefined,
        quantity: 1,
      },
    ],
    ...extra,
  });
}